[
  "acacia_door",
  "acacia_fence_gate",
  "acacia_button",
  "acacia_trapdoor",
  "anvil",
  "armor_stand",
  "barrel",
  "beacon",
  "bed_block",
  "bell",
  "birch_boat",
  "birch_button",
  "birch_door",
  "birch_fence_gate",
  "birch_trapdoor",
  "black_bed",
  "black_shulker_box",
  "blast_furnace",
  "blue_bed",
  "blue_shulker_box",
  "brewing_stand",
  "brown_bed",
  "brown_shulker_box",
  "campfire",
  "cauldron",
  "chest",
  "chest_minecart",
  "chipped_anvil",
  "command",
  "command_block",
  "command_block_minecart",
  "comparator",
  "composter",
  "crafting_table",
  "cyan_bed",
  "cyan_shulker_box",
  "damaged_anvil",
  "dark_oak_boat",
  "dark_oak_button",
  "dark_oak_fence_gate",
  "dark_oak_trapdoor",
  "dark_oak_door",
  "daylight_detector",
  "daylight_detector_inverted",
  "diode",
  "diode_block_off",
  "diode_block_on",
  "dispenser",
  "door",
  "dragon_egg",
  "dropper",
  "enchanting_table",
  "enchantment_table",
  "end_crystal",
  "end_portal_frame",
  "ender_portal_frame",
  "ender_chest",
  "explosive_minecart",
  "farmland",
  "fence_gate",
  "fletching_table",
  "flower_pot",
  "furnace",
  "furnace_minecart",
  "gray_bed",
  "gray_shulker_box",
  "green_bed",
  "green_shulker_box",
  "hopper",
  "hopper_minecart",
  "iron_door",
  "iron_trapdoor",
  "item_frame",
  "jukebox",
  "jungle_button",
  "jungle_boat",
  "jungle_door",
  "jungle_fence_gate",
  "jungle_trapdoor",
  "lever",
  "light_blue_bed",
  "light_blue_shulker_box",
  "light_gray_bed",
  "light_gray_shulker_box",
  "lime_bed",
  "lime_shulker_box",
  "magenta_bed",
  "magenta_shulker_box",
  "minecart",
  "note_block",
  "oak_boat",
  "oak_button",
  "oak_door",
  "oak_fence_gate",
  "oak_trapdoor",
  "orange_bed",
  "orange_shulker_box",
  "pink_bed",
  "pink_shulker_box",
  "powered_minecart",
  "purple_bed",
  "purple_shulker_box",
  "red_bed",
  "red_shulker_box",
  "redstone_ore",
  "redstone_comparator_off",
  "redstone_comparator_on",
  "repeating_command_block",
  "repeater",
  "powered_repeater",
  "unpowered_repeater",
  "redstone_torch",
  "saddle",
  "shulker_box",
  "sign",
  "sign_post",
  "smithing_table",
  "smoker",
  "spruce_boat",
  "spruce_button",
  "spruce_door",
  "spruce_fence_gate",
  "stonecutter",
  "stone_button",
  "storage_minecart",
  "tnt_minecart",
  "tnt",
  "trap_door",
  "trapped_chest",
  "white_bed",
  "white_shulker_box",
  "wood_button",
  "yellow_bed",
  "yelow_shulker_box"
]